import { Box, Link as MuiLink } from '@mui/material';
import * as React from 'react';
import palette from '../palette';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ICON_CLASS = 'BowtieLink-icon';
const disabledSx = {
  color: palette.GRAPHITE,
  cursor: 'default'
};
const gradientUnderline = {
  backgroundImage: `linear-gradient(transparent, transparent), linear-gradient(currentColor, currentColor) `,
  backgroundSize: '100% 2px, 0 2px',
  backgroundPosition: '100% 100%, 0 100%',
  backgroundRepeat: 'no-repeat',
  transition: '0.2s ease-out'
};
const shownUnderline = {
  backgroundSize: '0 2px, 100% 2px',
  backgroundPosition: '0 100%, 0 100%'
};
const Link = allProps => {
  const {
    children,
    disabled,
    icon,
    onClick,
    to,
    variant = 'body1',
    underline = 'hover',
    disableMultiline = false,
    type,
    iconPlacement = 'left',
    sx,
    ...props
  } = allProps;
  const rootSx = {
    cursor: 'pointer',
    verticalAlign: 'baseline',
    display: 'inline',
    '&[disabled]': disabledSx,
    paddingBottom: '3px',
    [`& .${ICON_CLASS}`]: {
      fontSize: 'inherit'
    },
    '&.MuiLink-button': {
      paddingBottom: icon ? '2px' : 0,
      '&[disabled]': disabledSx
    },
    ...(!disabled && underline !== 'none' && gradientUnderline),
    ...(underline === 'hover' && {
      '&:hover': {
        textDecoration: 'none',
        ...shownUnderline
      }
    }),
    ...(disableMultiline && {
      display: 'inline-flex',
      paddingBottom: 0
    }),
    ...(underline === 'always' && {
      textDecoration: 'none',
      ...shownUnderline
    }),
    ...(!!icon && {
      paddingBottom: '2px'
    })
  };
  return _jsxs(MuiLink, {
    sx: [rootSx, ...(Array.isArray(sx) ? sx : [sx])],
    disabled: disabled,
    onClick: disabled ? e => e.preventDefault() : onClick,
    to: disabled ? null : to,
    variant: variant,
    underline: underline,
    ...(props.component === 'button' && {
      type: type || 'button'
    }),
    ...props,
    children: [icon && iconPlacement === 'left' && _jsx(Box, {
      component: icon,
      className: ICON_CLASS,
      sx: {
        margin: 'auto 0',
        minWidth: 20,
        minHeight: 20,
        verticalAlign: 'text-bottom',
        pr: 0.5
      }
    }), children, icon && iconPlacement === 'right' && _jsx(Box, {
      component: icon,
      className: ICON_CLASS,
      sx: {
        margin: 'auto 0',
        minWidth: 20,
        minHeight: 20,
        verticalAlign: 'text-bottom',
        pl: 0.5
      }
    })]
  });
};
export default Link;